import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'

export const quoteEditorVariants = [
  InvoiceEditorVariant.QuoteDraftDuplicate,
  InvoiceEditorVariant.QuoteDraftEdit,
  InvoiceEditorVariant.QuoteDuplicate,
  InvoiceEditorVariant.QuoteEdit,
  InvoiceEditorVariant.QuoteNew,
]
